
import Head from 'next/head'
import { getBlogs, getFAQs } from '@/lib/data'
import BlogCard from '@/components/BlogCard'
import FAQ from '@/components/FAQ'

export default function BlogsPage({ blogs, faqs }: any) {
  return (
    <>
      <Head>
        <title>Blog & Ratgeber | Autoverwertung Deutschland</title>
        <meta name="description" content="Lesen Sie aktuelle Blogartikel und Ratgeber rund um Autoverwertung, KFZ-Ankauf und nachhaltige Fahrzeugentsorgung in Deutschland." />
        <meta property="og:title" content="Blog & Ratgeber | Autoverwertung Deutschland" />
        <meta property="og:description" content="Lesen Sie aktuelle Blogartikel und Ratgeber rund um Autoverwertung, KFZ-Ankauf und nachhaltige Fahrzeugentsorgung in Deutschland." />
        <meta property="og:image" content="/images/cars/reccar.webp" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://autoverwertungs.de/blogs" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Blog & Ratgeber | Autoverwertung Deutschland" />
        <meta name="twitter:description" content="Lesen Sie aktuelle Blogartikel und Ratgeber rund um Autoverwertung, KFZ-Ankauf und nachhaltige Fahrzeugentsorgung in Deutschland." />
        <meta name="twitter:image" content="/logo.jpeg" />
        <meta name="robots" content="index, follow" />
      </Head>
      <div className="container mx-auto px-4 py-8 md:py-12 lg:py-16">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 md:mb-8">Alle Blogs</h1>
        <div className="grid sm:grid-cols-2 gap-6">
          {blogs.map((b: any) => (
            <BlogCard key={b.slug} blog={b} />
          ))}
        </div>
      </div>
      <FAQ faqs={faqs} />
    </>
  )
}

export async function getStaticProps() {
  const blogs = await getBlogs()
  const faqs = await getFAQs()
  return { props: { blogs, faqs } }
}
